<template>
  <div class="check-dialog-content">
    <el-dialog
      :title="stageName+'---'+youthName +  totalScoreTitle"
      :visible.sync="isShow"
      width="680px"
      :close-on-click-modal="false"
      :before-close="handleDialogBeforeClose"
    >
<!--      <div class="dialog-content-wrapper">-->
      <div class="form-content-wrapper">
        <vue-scroll :ops="ops">
          <div class="scroll-content">
            <template >
              <el-form
                ref="scoreFormDom"
                :model="scoreForm"
                label-width="100px"
              >
              <div class="form-wrapper dialog-item">
                <div v-for="(item, index) in scoreForm.baseScoreList"
                  :key="index" style="margin-right:20px">
                  <el-divider content-position="center">对 “{{item.scoreType | scoreTypeFiler}}” 打分
                    <span v-if="item.scoreType === 'schooltrain'">(除“体教融合”之外在“评估管理”中普及培训还有体现)</span>
                    <span v-if="item.scoreType === 'event'">(除“训练计划”之外在“评估管理”中普及培训还有体现)</span>
                    <span v-if="item.scoreType === 'plan'">(除“教案库”之外在“评估管理”中普及培训还有体现)</span>
                  </el-divider>
                  <el-form-item label="评估打分" :prop="`baseScoreList.${index}.score`" :rules="[{ required: true, message: '请打分', trigger: ['blur', 'change']}]">
                    <el-input-number
                      v-model.number="item.score"
                      :min="0"
                      :disabled="configInfo.isDisabled"
                      :max="item.scoreFull || 0"
                      label="请填写分值"
                      @change="changeScore()"
                      @blur="changeScore()"
                    ></el-input-number>
                    （满分：{{item.scoreFull}}分）
                  </el-form-item>


                  <el-form-item :label="item.score === item.scoreFull ? '审核备注：' : '扣分原因：'"
                    :prop="`baseScoreList.${index}.auditRemark`" :rules="[{ required: item.score !== item.scoreFull, message: item.score === item.scoreFull ? '请输入审核备注' : '请输入扣分原因', trigger: 'blur'}]">
                    <el-input
                      type="textarea"
                      :rows="2"
                      class="w350"
                      v-model="item.auditRemark"
                      :disabled="configInfo.isDisabled"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="整改建议："
                    :prop="`baseScoreList.${index}.rectificationSuggestion`" :rules="[{ required: item.score !== item.scoreFull, message: '请输入整改建议', trigger: 'blur'}]">
                    <el-input
                      type="textarea"
                      :rows="2"
                      class="w350"
                      v-model="item.rectificationSuggestion"
                      :disabled="configInfo.isDisabled"
                      placeholder="请输入整改建议"
                    ></el-input>
                  </el-form-item>

                  <span style="color:#f88594;margin-left:20px" v-if="!configInfo.isDisabled">
                    * 每一项分数填写完成后请点击保存
                  </span>
                  <template v-if="!configInfo.isDisabled">
                    <div class="btns-group">
                      <!--<el-button type="primary" :loading="addbtnLoading" @click="handleUploadBtn(true,'Edit')"-->
                      <!--&gt;暂时保存</el-button-->
                      <!--&gt;-->
                      <el-button type="primary" :loading="addbtnLoading" @click="handleUploadBtn(true,'Edit',item,index)"
                      >保存</el-button
                      >
                      <!--<el-button type="danger" :loading="addbtnLoading" @click="handleUploadBtn(false,'Danger')"-->
                      <!--&gt;关闭</el-button-->
                      <!--&gt;-->
                    </div>
                  </template>
                </div>
              </div>
              </el-form>
            </template>


          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ops } from "@/utils/scrollIndialog";
import {
  downloadMutileFile,
  downloadTargetFileListForYouth,
  putSecondTargetAuditScore,
  replaceSecondTargetAuditScore,
  getTargetLabelList,
  getTargetFileList,
  experToYouthAuditData,
  experToYouthAuditSave
} from "@/api/performance";
import { downloadByJs } from "@/utils/commen";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { scoreTypeFiler } from "@/assets/js/yioksFilters";
import mixinAppConfig from "@/mixin/mixinAppConfig";

export default {
  mixins: [mixinAppConfig],
  components: {
    "yioks-empty": () => import("@/components/YioksEmpty"),
  },

  props: {
    isShow: {
      type: Boolean,
      default: false,
      required: true,
    },

    configInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      ops,
      scoreTypeFiler,
      requiredItem,
      labelList: [],
      downloadFilelist: [],
      totalScore:0,
      totalScoreTitle:"",
      scoreForm:{
        youthUuid:this.youthUuid,
        stageUuid:this.stageUuid,
        auditStatus:"",
        baseScoreList: [ // 球队组别
          {
            score: 0,
            auditRemark: "",
            rectificationSuggestion: "",
            scoreType: "",
            scoreFull:"",
          },
        ],
      },

      formData: {},
      stageName:"",
      youthName:"",

      addbtnLoading: false,
    };
  },
  filters: {
    scoreTypeFiler
  },
  computed: {

    stageUuid() {
      const { stageUuid } = this.configInfo;
      return stageUuid || "";
    },
    youthUuid() {
      const { youthUuid } = this.configInfo;
      return youthUuid || "";
    },

  },

  created() {
    this.loadLabelList();
  },

  methods: {
    // 处理弹窗
    handleDialogBeforeClose() {
      this.setDialogStatus(false);
    },

    // 设置弹窗状态
    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    // 加载补充信息
    loadLabelList() {
      experToYouthAuditData(this.youthUuid,this.stageUuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.stageName = res.stageName;
          this.youthName = res.youthName;
          this.scoreForm.baseScoreList = res.baseScoreList;
          this.scoreForm.youthUuid = this.youthUuid;
          this.scoreForm.stageUuid = this.stageUuid;
          this.changeScore();

        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    changeScore(){
      this.totalScore = 0;
      this.totalScoreTitle = "";
      this.scoreForm.baseScoreList.map(item=>{
        if(item.score > 0){
          this.totalScore = this.totalScore +item.score
        }
      })
      if(this.totalScore > 0){
        this.totalScoreTitle = "（共" + this.totalScore + "分）";
      }
    },
    // 机构打分
    handleUploadBtn(flag,status,item,index) {
      if (flag) {
        this.$refs["scoreFormDom"].validateField(`baseScoreList.${index}.auditRemark`,(valid) => {
          if(!valid){ // 校验通过
              this.$refs["scoreFormDom"].validateField(`baseScoreList.${index}.rectificationSuggestion`,(valid) => {
                if(!valid){ // 校验通过
                  this.saveScore(status,item);
                }
              })
          }
        });
      } else {
        this.$emit("update:isShow", false);
      }
    },

    saveScore(status,item){
      this.addbtnLoading = true
      // this.$emit("update:isShow", false); // 关闭弹窗
      this.scoreForm.auditStatus = status;
      const sub = {
        ...this.scoreForm
      };
      sub.baseScoreList = [];
      sub.baseScoreList.push(item);
      experToYouthAuditSave(sub)
      .then((res) => {
        this.addbtnLoading = false
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success('评估成功')
        this.loadLabelList();
//        this.$emit("callbackForClub", true);
      })
      .catch((err) => {
        this.addbtnLoading = false
        console.error("err", err);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.dialog-footer
  width 60%
  margin 40px auto 40px
  display flex
  justify-content space-around
.action-box
  padding-left 120px
  margin-bottom 20px
.download-list-wrapper
  padding 0px 20px 20px 50px !important
  .download-item
    font-size 16px
    line-height 1.2em
    margin-bottom 10px
    &:last-child
      margin-bottom 0px
    a
      margin-left 8px
      color $green_color !important
.item-title
  font-size 24px
  height 40px
  display flex
  align-items center
  padding-left 20px
  margin-bottom 15px
.dialog-item
  margin-bottom 25px
.dialog-content
  height 380px
  .scroll-content
    margin 0 30px 0 20px
.yioks-form-item
  width 360px
.form-wrapper
  padding 0px 0px 0px 20px
.btns-group
  width 100%
  margin 0 auto
  display flex
  justify-content center
.w350
  width 480px

.form-content-wrapper
  height 480px
</style>
